// extracted by mini-css-extract-plugin
export default {"Sidebar":"Sidebar_Sidebar__q86bU","collapseButtonWrapper":"Sidebar_collapseButtonWrapper__JBJAb"};